import { createContext, useContext, type ReactNode } from "react";

/**
 * True inside the admin panel's live preview.
 *
 * The preview renders the real public components in a frame, and two things
 * that are right on the public site are wrong there: reveal animations wait for
 * the element to scroll into view, which inside a scaled frame they may never
 * appear to do, and each section needs a marker so the frame can scroll to the
 * one being edited. Both read this. The public site never sets it.
 */
const PreviewModeContext = createContext(false);

export function PreviewModeProvider({ children }: { children: ReactNode }) {
  return <PreviewModeContext.Provider value={true}>{children}</PreviewModeContext.Provider>;
}

export const usePreviewMode = () => useContext(PreviewModeContext);
